import React from 'react';
import { Separator } from 'react-resizable-panels';
import './ResizeHandle.css';

interface ResizeHandleProps {
  direction?: 'horizontal' | 'vertical';
  id?: string;
}

export const ResizeHandle: React.FC<ResizeHandleProps> = ({
  direction = 'vertical',
  id
}) => {
  return (
    <Separator
      className={`resize-handle resize-handle-${direction}`}
      id={id}
    >
      <div className="resize-handle-indicator" />
    </Separator>
  );
};

export default ResizeHandle;
